module.exports = __webpack_public_path__ + "img/statutory.207490dc.svg";